import { ReactNode } from 'react'
import { Tag } from '@/components/Tag'

export interface DetailTableRow {
	label: string
	value: string | ReactNode
	valueClassName?: string
}

interface DetailTableProps {
	rows: DetailTableRow[]
	className?: string
}

export function DetailTable ({ rows, className = '' }: DetailTableProps) {
	return (
		<dl
			className={`spaces-detail-table spaces:border spaces:border-canvas-3 spaces:rounded-12 spaces:overflow-hidden ${className}`}
		>
			{rows.map((row, i) => (
				<div
					key={i}
					className={`spaces-detail-table-row spaces:flex spaces:items-start ${
						i < rows.length - 1 ? 'spaces:border-b spaces:border-canvas-3' : ''
					}`}
				>
					<dt className='spaces:w-[120px] spaces:shrink-0 spaces:p-12'>
						<span className='spaces:text-16/24 spaces:font-default spaces:text-content-3'>
							{row.label}
						</span>
					</dt>
					<dd className={`spaces:flex-1 ${row.valueClassName ?? 'spaces:p-12'}`}>
						{typeof row.value === 'string' ? (
							<span className='spaces:text-16/24 spaces:font-default spaces:text-content-1'>
								{row.value}
							</span>
						) : (
							row.value
						)}
					</dd>
				</div>
			))}
		</dl>
	)
}
